import { OwcButton } from '@one/react';
import { useTranslation } from 'core/i18n';
import { LoadErrorMessageComponent } from '../../generic-error';
import { WorkflowErrorBodyLayout, WorkflowErrorFooterLayout } from './workflow-error.style';

interface WorkflowErrorComponentProps {
  onRetry?: VoidFunction;
  onGoHome?: VoidFunction;
}

export const WorkflowErrorComponent: React.FC<WorkflowErrorComponentProps> = props => {
  const { onRetry, onGoHome } = props;
  const { t } = useTranslation('common');

  return (
    <>
      <WorkflowErrorBodyLayout>
        <LoadErrorMessageComponent />
      </WorkflowErrorBodyLayout>
      <WorkflowErrorFooterLayout>
        <OwcButton variant="primary" onClick={onRetry} data-testid="workflow-error-retry">
          {t('components.workflow-error.retry')}
        </OwcButton>
        <OwcButton variant="secondary" onClick={onGoHome} data-testid="workflow-error-go-home">
          {t('components.workflow-error.go-home')}
        </OwcButton>
      </WorkflowErrorFooterLayout>
    </>
  );
};
